"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


//////////////////
// WEBPACK FOOTER
// ./~/accessibility/dist/interfaces/menu.interface.js
// module id = I6E3
// module chunks = 16